import { useState, useCallback } from 'react';

export enum EMBigScreenTimeFrame {
  TODAY = 'current_day', // 今日
  CURRENT_MONTH = 'current_month', // 本月
  LAST_MONTH = 'last_month', // 上个月
  NEARLY_HALF_A_YEAY = 'nearly_half_a_year', // 近半年
  NEARLY_A_YEAY = 'nearly_a_year', // 近一年
}

export default function DataCenterBigScreenFilter() {
  const [timeFrame, setTimeFrame] = useState<EMBigScreenTimeFrame>();
  const [businessType, setBusinessType] = useState();
  const [statisticLoading, setStatisticLoading] = useState(false);
  const [cityTablePage, setCityTablePage] = useState(1);

  const setTimeFrameCb = useCallback((val) => {
    setCityTablePage(1);
    setTimeFrame(val);
  }, []);
  const setBusinessTypeCb = useCallback((val) => {
    setCityTablePage(1);
    setBusinessType(val);
  }, []);
  const setStatisticLoadingCb = useCallback((val) => {
    setStatisticLoading(val);
  }, []);
  const setCityTablePageCb = useCallback((val) => {
    setCityTablePage(val);
  }, []);
  return {
    timeFrame,
    setTimeFrameCb,
    businessType,
    setBusinessTypeCb,
    statisticLoading,
    setStatisticLoadingCb,
    cityTablePage,
    setCityTablePageCb,
  };
}
